/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
// Importing necessary hooks and actions from libraries and Redux
import {useDispatch} from "react-redux"; // useDispatch for dispatching Redux actions
import {useTranslation} from "react-i18next"; // useTranslation for localization and translations
import { RemoveTemplates} from "../../../reduxToolkit/Cards/CardsApi";
import {toast} from "react-toastify"; // Action to assign templates to cards

// The DisassignTemplateApp component
const DisassignTemplateApp = ({onHide, selectedCards, setModified}) => {
    const { t } = useTranslation(); // Initializes translation function for localization
    const dispatch = useDispatch(); // Redux dispatch function for dispatching actions

    // Function to handle assigning the selected template to the selected cards
    const handleConfirm = () => {
        // Dispatch action to disassign the template to the selected cards
        dispatch(RemoveTemplates(selectedCards)).then(
            ({payload: {data: { success, code }}}) => {
                if (success) { // If the template was successfully disassign
                    toast.success(t('has_been_disassigning_successfully')); // Display a general error message
                    onHide(); // Call the onHide function to close the modal or form
                    setModified(true); // Set modified state to true indicating changes have been made
                } else {
                    toast.error(t('something_went_wrong_2')); // Display a general error message
                    onHide(); // Call the onHide function to close the modal or form
                }
            },
        );
    };

    // Return the necessary values and functions for use within the component's UI
    return {
        t, // Translation function
        handleConfirm, // Function to handle template assignment to cards
    };
}

export default DisassignTemplateApp;
